var _classCallCheck = require("/Users/dandregregory/workspace/EEMERGPLATFORM/SP_SIGNUP_APP/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/dandregregory/workspace/EEMERGPLATFORM/SP_SIGNUP_APP/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var ErrorCollector =
/*#__PURE__*/
function () {
  "use strict";

  function ErrorCollector() {
    _classCallCheck(this, ErrorCollector);

    this.errors = [];
  }

  _createClass(ErrorCollector, [{
    key: "collect",
    value: function collect(error) {
      this.errors.push(error);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.errors = [];
    }
  }, {
    key: "get",
    value: function get() {
      return this.errors.filter(function (error) {
        return error !== null;
      });
    }
  }]);

  return ErrorCollector;
}();

module.exports = ErrorCollector;